import { Injectable } from '@angular/core';
import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';

@Injectable()
export class LoginPageNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  public constructor() {
    super('LOGIN', 'menu.label.login', `/${AppRoute.Login}`, 'a11y.link.login');
  }
}
